<template>
  <div>

        <el-card shadow="never">
          Filter by Date and Location
          <br>
          <el-form label-position="top"  size="small" >  
         
          <el-select
            size="mini"
            class="form-group border-input"
            placeholder="Select Country"
            v-model="country"
            @change="getTownsByCountry"
          >
          
            <el-option
              v-for="(country,index) in countries"
              class="select-default"
              :value="country"
              :label="index"
              :key="index"
            ></el-option>
          </el-select>
            
          
          <el-select
            size="mini"
            class="form-group border-input"
            placeholder="Select Location"
            v-model="town"
            v-on="{change:dates ? getClassroomsByTown : function(){return false}}"
          >
            <el-option
              v-for="(town,index) in towns"
              class="select-default"
              :value="town.town"
              :label="town.town"
              :key="index"
            ></el-option>
          </el-select>
             
          <el-date-picker
            v-model="dates"
            type="daterange"
            range-separator="- "
            @change="getClassroomsByTown"
            start-placeholder="Start"
            end-placeholder="End"
            size="mini"
          ></el-date-picker>
          <el-button
            size="mini"
            @click="dates=''"
            type="text"
            icon="el-icon-circle-close"
            circle
          >clear dates</el-button>
          </el-form>
        </el-card>

   
  </div>
</template>
<script>
import json from "../../data/countries.json";
import { commonApi } from "../../api/common.js";
import { QUERY_STORED  } from '../../store/modules/queries'
import moment from "moment";
export default {
  name: "classroom-filter",
  data() {
    return {
      countries: json,
      towns: {},
      classrooms: [],
      total: 0
    };
  },
  methods: {
    getTownsByCountry(country) {
      const townsPromise = commonApi.getTownsByCountry({ country: country });
      Promise.resolve(townsPromise).then(result => {
        this.towns = result.data;
      });
    },
    getClassroomsByTown(town) {
          this.$emit("loading", true);
      const countryPromise = commonApi.getClassroomsByTown({
        town: this.town,
        dates: this.dates
      });
       this.$store.dispatch(QUERY_STORED, { 
         country:this.country,
        town: this.town,
        dates: this.dates

        })
      Promise.resolve(countryPromise).then(result => {
        this.classrooms = result.data;
        this.total = result.data.length
          this.$emit("total", this.total);
         this.$emit("loading", false);
        this.$emit("update:classrooms", this.classrooms);
      });
    }
  },
 
    computed:{
      country:{ get(){return this.$store.getters.getQueries.country},set(value){ this.$store.commit('updatecountry', value)}},
      town:{get(){return this.$store.getters.getQueries.town},set(value){ this.$store.commit('updatetown', value)}},
      dates:{get(){return this.$store.getters.getQueries.dates},set(value){ this.$store.commit('updatedates', value)}}
    },
    async mounted(){
      this.getClassroomsByTown(this.town)
      this.getTownsByCountry(this.country)
    }
};
</script>
<style scoped>
.min > *{
  padding:0 !important;margin:0 !important;
}
label{
  display: inline-block;
 padding:0 !important;margin:0 !important;
 font-weight:100 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/ClassroomFilter.vue